import { Injectable } from '@angular/core';
import { AltraParte } from './altraparte';
import { AttivitaFattura } from './attivita-fatture';
import { DocumentoAllegato } from './documento-allegato';
import { Iva } from './tipologiche/iva';

@Injectable()
export class Fattura {
  id: string;
  altraParte: AltraParte;
  dataEmissione: number;
  numeroFattura: string;
  numeroGiorniPagamento: number;
  totaleImportoAttivita: any;
  speseEsenti: any;
  speseImponibili: any;
  iva: Iva;
  flagIva: boolean;
  flagContributoPrevidenziale: boolean;
  descrizioneContributoPrevidenziale: string;
  percentualeContributoPrevidenziale: number;
  flagAltreSpese: boolean;
  descrizioneAltreSpese: string;
  percentualeAltreSpese: number;
  flagRitenutaAcconto: boolean;
  attivitaFatture: AttivitaFattura[];
  note: string;
  documenti: DocumentoAllegato[];
}
